import { render } from "./CarrierEdit.vue?vue&type=template&id=495382b2"
import script from "./CarrierEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CarrierEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Carrier/CarrierEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "495382b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('495382b2', __exports__)) {
    api.reload('495382b2', __exports__)
  }
  
  module.hot.accept("./CarrierEdit.vue?vue&type=template&id=495382b2", () => {
    api.rerender('495382b2', render)
  })

}


export default __exports__